import { createAction } from '@reduxjs/toolkit';
import {
  AaasFeaturePermission,
  AdminTheme,
  ExternalSubscription,
  GroupedPackages,
  IntpWebsite,
  StpCounterResponse,
} from '@va/aaas/shared/types';
import { apiStatus } from '@va/constants';

export const initialize = createAction<void>('INITIALIZE');
export const initializeSucceeded = createAction<void>('INITIALIZE_SUCCEEDED');
export const setIntpWebsite = createAction<IntpWebsite>('SET_INTP_WEBSITE');

/**
  This is the subscription we fetch directly from the payment provider we use for 3as platform billing ( Stripe subscription at the moment of writting )
*/
export const setExternalSubscription = createAction<ExternalSubscription | undefined | null>(
  'SET_EXTERNAL_SUBSCRIPTION',
);
export const setExternalSubscriptionStatus = createAction<apiStatus>('SET_EXTERNAL_SUBSCRIPTION_STATUS');
export const getExternalSubscriptionRequest = createAction('GET_EXTERNAL_SUBSCRIPTION_REQUEST');

export const setTheme = createAction<AdminTheme>('SET_CUSTOM_THEME');
export const setFeaturePermissions = createAction<AaasFeaturePermission[]>('SET_FEATURE_PERMISSIONS');
export const setIsFirstLogin = createAction<boolean>('SET_IS_FIRST_LOGIN');
export const setFeaturePermissionsStatus = createAction<apiStatus>('SET_FEATURE_PERMISSIONS_STATUS');
export const setStpRates = createAction<StpCounterResponse>('SET_STP_RATES');
export const setAllowUpgrade = createAction<boolean>('SET_ALLOW_UPGRADE');
export const setExternalWebsiteId = createAction<string>('SET_EXTERNAL_WEBSITE_ID');

export const setPackages = createAction<GroupedPackages>('SET_PACKAGES');

export const getStpRatesRequest = createAction('GET_STP_RATES_REQUEST');
export const getIntpWebsiteRequest = createAction('GET_INTP_WEBSITE_REQUEST');

export const syncAppStateAfterSubscriptionUpgradeRequest = createAction<{ newPackageId: string }>(
  'SYNC_APP_STATE_AFTER_SUBSCRIPTION_UPGRADE_REQUEST',
);
